import { c as _c } from "react/compiler-runtime";
import React from 'react';
const InvalidTrackingRequest = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div>Invalid Tracking Request</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default InvalidTrackingRequest;